import { z } from "zod"
import { ProviderCalendarIdSchema } from "@/scalars/providerCalendarId"

const MeterPointPmaxSchema = z.object({
    meterPointId: z.string(),
    providerCalendarId: ProviderCalendarIdSchema.nullable(),
    user: z.object({
        email: z.string().nullable(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
        accountNumber: z.string().nullable(),
    }),
})

export const MeterPowerAnalysisFormValuesSchema = z
    .object({
        affiliateCode: z.string().nullable(),
        rewardCode: z.string().nullable(),
        productCode: z.string().nullable(),
        pmaxToken: z.string().nullable(),
        currentSubscribedMaxPower: z.number().nullable(),
        recommendedSubscribedMaxPower: z.number().nullable(),
        yearlyProfitAmountCents: z.number().nullable(),
        isFromDashboard: z.boolean(),
        errorCode: z.string().nullable(),
    })
    .and(MeterPointPmaxSchema)
